import { type providers, type Signer, utils } from 'ethers';
import { defineMessages, type IntlShape } from 'dibs-react-intl';

const messages = defineMessages({
    walletConnect: {
        id: 'crypto-utils.walletConnectSignedMessage',
        defaultMessage:
            'From 1stDibs: Please sign this message so that we may verify your Ethereum wallet address. This does not require a gas fee.\n\nThanks!\n\n(User ID: {userId})',
    },
    zipCodeUpdate: {
        id: 'crypto-utils.zipCodeUpdateSignedMessage',
        defaultMessage:
            'From 1stDibs: Please sign this message so that we may update your zip code. This does not require a gas fee.\n\nThanks!\n\n(User ID: {userId})',
    },
});

export async function signMessage(
    signer: Signer | undefined,
    userId: string,
    { formatMessage }: { formatMessage: IntlShape['formatMessage'] },
    messageKey: keyof typeof messages = 'walletConnect',
    library?: providers.JsonRpcProvider
):
    | Promise<{
          message: string;
          signature: string | null;
      }>
    | never {
    if (!signer) {
        throw new Error('signMessage: signer is required!');
    }
    const msg = formatMessage(messages[messageKey], { userId });
    const message = btoa(msg);
    const address = await signer.getAddress();
    if (library) {
        const signature = await library.send('personal_sign', [
            utils.hexlify(utils.toUtf8Bytes(msg)),
            address.toLowerCase(),
        ]);
        return { signature, message };
    }
    const signature = await signer.signMessage(msg);
    return { signature, message };
}
